import React, { useState } from 'react'
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useFormik } from 'formik';
import * as Yup from "yup";
import { changePassword } from '../../redux/reducers/authSlice';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));
const ChangePasswordModal = ({ open, setOpen }) => {
    const dispatch = useDispatch()
    const [isPwdShown, setIsPwdShown] = useState(true);
    const [isPwdShownNew, setIsPwdShownNew] = useState(true);
    const [isPwdShownConfirm, setIsPwdShownConfirm] = useState(true);

    const initialValues = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
    }
    let validationSchema = Yup.object().shape({
        oldPassword: Yup.string()
            .min(8, "Must be 8 or more than 8 characters")
            .required("This field is required."),
        newPassword: Yup.string()
            .min(8, "Must be 8 or more than 8 characters")
            .required("This field is required."),
        confirmPassword: Yup.string()
            .min(8, "Must be 8 or more than 8 characters")
            .oneOf([Yup.ref("newPassword"), ""], "Password must match")
            .required("This field is required."),
    });
    const changepassFormik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            let body = {
                oldPassword: values.oldPassword,
                newPassword: values.newPassword
            }
            dispatch(changePassword({body:body,setOpen:setOpen}))
        }
    })
    return (
        <React.Fragment>
            <BootstrapDialog className="editmodal-wrap"
                onClose={() => setOpen(false)}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className="editmodal-heading">
                    Change Password
                </DialogTitle>
                <form onSubmit={changepassFormik.handleSubmit}>
                    <DialogContent className="edit-Modal-body" dividers>
                        <div className="row">
                            <div className="mb-3 form-password-toggle">
                                <div className="position-relative">
                                    <label className="form-label" htmlFor="password">
                                        Old Password *
                                    </label>
                                    <div className="input-group input-group-merge ">
                                        <input
                                            type={isPwdShown ? "password" : "text"}
                                            id="oldPassword"
                                            className="form-control"
                                            name='oldPassword'
                                            value={changepassFormik?.values.oldPassword}
                                            onChange={changepassFormik.handleChange}
                                            placeholder=""
                                            aria-describedby="oldPassword"
                                        />
                                        <span className="input-group-text cursor-pointer">
                                            <FontAwesomeIcon
                                                icon={
                                                    isPwdShown ?
                                                        icon({ name: "eye-slash" })
                                                        : icon({ name: "eye" })
                                                }
                                                onClick={() => setIsPwdShown(!isPwdShown)}
                                            />
                                        </span>
                                    </div>
                                </div>
                                <p className='form-error-message'>{changepassFormik.touched.oldPassword &&
                                    changepassFormik.errors.oldPassword}</p>
                            </div>
                            <div className="mb-3 form-password-toggle">
                                <div className="position-relative">
                                    <label className="form-label" htmlFor="password">
                                        New Password *
                                    </label>
                                    <div className="input-group input-group-merge ">
                                        <input
                                            type={isPwdShownNew ? "password" : "text"}
                                            id="newPassword"
                                            className="form-control"
                                            name='newPassword'
                                            value={changepassFormik?.values.newPassword}
                                            onChange={changepassFormik.handleChange}
                                            placeholder=""
                                            aria-describedby="newPassword"
                                        />
                                        <span className="input-group-text cursor-pointer">
                                            <FontAwesomeIcon
                                                icon={
                                                    isPwdShownNew ?
                                                        icon({ name: "eye-slash" })
                                                        : icon({ name: "eye" })
                                                }
                                                onClick={() => setIsPwdShownNew(!isPwdShownNew)}
                                            />
                                        </span>
                                    </div>
                                </div>
                                <p className='form-error-message'>{changepassFormik.touched.newPassword &&
                                    changepassFormik.errors.newPassword}</p>
                            </div>
                            <div className="mb-3 form-password-toggle">
                                <div className="position-relative">
                                    <label className="form-label" htmlFor="password">
                                        Confirm Password *
                                    </label>
                                    <div className="input-group input-group-merge ">
                                        <input
                                            type={isPwdShownConfirm ? "password" : "text"}
                                            id="confirmPassword"
                                            className="form-control"
                                            name='confirmPassword'
                                            value={changepassFormik?.values.confirmPassword}
                                            onChange={changepassFormik.handleChange}
                                            placeholder=""
                                            aria-describedby="confirmPassword"
                                        />
                                        <span className="input-group-text cursor-pointer">
                                            <FontAwesomeIcon
                                                icon={
                                                    isPwdShownConfirm ?
                                                        icon({ name: "eye-slash" })
                                                        : icon({ name: "eye" })
                                                }
                                                onClick={() => setIsPwdShownConfirm(!isPwdShownConfirm)}
                                            />
                                        </span>
                                    </div>
                                </div>
                                <p className='form-error-message'>{changepassFormik.touched.confirmPassword &&
                                    changepassFormik.errors.confirmPassword}</p>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button className="btn" autoFocus type="submit">
                            Save changes
                        </Button>
                    </DialogActions>
                </form>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default ChangePasswordModal